import React from 'react'
import { useNavigate } from 'react-router-dom';
import { auth } from '../config/firebase.config';
import '../index.css';

const Home = () => {
  const user = auth.currentUser;
  const navigate = useNavigate();

  React.useEffect(() => {
    if (user) return navigate('/dashboard')
  }, []);

  return (
    <div>
      <div className="my-[15%] text-center text-xl md:text-5xl" style={{ fontFamily: 'cursive' }}>
        <h1 className='animate-bounce mt-[-1%]'>
          Documentor will Help You
        </h1>
        <h1 className='animate-bounce mt-5'>
          to Store Your Document near You
        </h1>
      </div>
    </div>
  )
}

export default Home